// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"_7GSn7l5Wlc1eVgNM2n5vu","spaceLeft":"_1_vWKS7nOGpaJKStN6NyNV","spaceBoth":"_1NWpgeUR33wjXk68AzuVA2","spaceRight":"i4Jjd3X1uyfATMSj0pLNX","available":"_80r8G9KzzpYIYC61j11BT","callToAction":"etgq7Nn3tYVskWXdiq1Zq","footer":"_213M-hU6VK_HC7Vify4v39","helpBlock":"_2Hc3gwEqa-Il9VHJeAgyq6"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/OasisMakeOffer.scss
// module id = 481
// module chunks = 0